export const minWidth800 = { minWidth: 800 };
